export default "__VITE_ASSET__Uej79w95__"